import React from "react";
import { Container, Row } from "react-bootstrap";

const CommonContainer = ({ className = "", children }) => {
    return (
        <Container fluid className="pt-2">
            <Row className={className}>
                {children}
            </Row>
        </Container>
    );
};

export default CommonContainer;